import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["gtmEvents", "clickState", "clickId"];
import React from 'react';
import PropTypes from 'prop-types';
import GTMClickEvents from './GTMClickEvents';
import GTMEventFactory from './GTMEventFactory';
import { filterGtmEvents } from '../helpers';
const GTMEventSwitch = _ref => {
  let {
      gtmEvents,
      clickState,
      clickId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (typeof window === 'undefined' || !gtmEvents.length) return null;
  const {
    clickEvents,
    regularEvents
  } = filterGtmEvents(gtmEvents);
  const GTMClickFactory = clickId ? GTMEventFactory : GTMClickEvents;
  return clickState ? /*#__PURE__*/React.createElement(GTMClickFactory, _extends({
    gtmEvents: clickEvents,
    clickId: clickId
  }, props)) : /*#__PURE__*/React.createElement(GTMEventFactory, _extends({
    gtmEvents: regularEvents
  }, props));
};
GTMEventSwitch.propTypes = {
  clickId: PropTypes.string,
  gtmEvents: PropTypes.array,
  clickState: PropTypes.bool
};
GTMEventSwitch.defaultProps = {
  clickId: null,
  gtmEvents: [],
  clickState: false
};
export default GTMEventSwitch;
//# sourceMappingURL=GTMEventSwitch.js.map